export enum RELATIONSHIPS {
  SELF,
  CONNECTED,
  REQUESTED_OUT,
  REQUESTED_IN,
  NONE,
}
